import { render, staticRenderFns } from "./list-question.vue?vue&type=template&id=751ae9d4&"
import script from "./list-question.vue?vue&type=script&lang=js&"
export * from "./list-question.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports